module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5m7PR"))).then(() => parcelRequire('fThBo'));